/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconWarningError from '@telus-uds/palette-public-mobile/build/rn/icons/WarningError'
import PaletteIconCheckMark from '@telus-uds/palette-public-mobile/build/rn/icons/CheckMark'
import PaletteIconMobileRewards from '@telus-uds/palette-public-mobile/build/rn/icons/MobileRewards'
const theme = {
  appearances: {
    inverse: {
      description: 'Inverts the status colors',
      type: 'variant',
      values: [ true ]
    },
    priority: { type: 'variant', values: [ 'default', 'low', 'high' ] },
    purpose: {
      type: 'variant',
      values: [
        'default', 'brand',
        'subtle',  'success',
        'warning', 'error',
        'offer'
      ]
    }
  },
  rules: [
    { if: { purpose: 'brand' }, tokens: { iconColor: '#394056' } },
    { if: { purpose: 'subtle' }, tokens: { iconColor: '#6a7080' } },
    {
      if: { purpose: 'success' },
      tokens: { icon: PaletteIconCheckMark, iconColor: '#2b826e' }
    },
    {
      if: { purpose: 'warning' },
      tokens: { icon: PaletteIconWarningError, iconColor: '#bf1722' }
    },
    {
      if: { purpose: 'error' },
      tokens: { icon: PaletteIconWarningError, iconColor: '#bf1722' }
    },
    {
      if: { purpose: 'offer' },
      tokens: { icon: PaletteIconMobileRewards, iconColor: '#f39d80' }
    },
    {
      if: { priority: 'low' },
      tokens: {
        borderRadius: 99,
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4
      }
    },
    {
      if: { priority: 'high' },
      tokens: {
        backgroundColor: '#394056',
        borderRadius: 99,
        iconColor: '#cdcfd5',
        paddingBottom: 4,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4,
        textColor: '#cdcfd5'
      }
    },
    {
      if: { priority: 'low', purpose: 'default' },
      tokens: { backgroundColor: '#cdcfd5' }
    },
    {
      if: { priority: 'high', purpose: 'default' },
      tokens: { backgroundColor: '#394056' }
    },
    {
      if: { priority: 'low', purpose: 'brand' },
      tokens: { backgroundColor: '#cdcfd5' }
    },
    {
      if: { priority: 'high', purpose: 'brand' },
      tokens: { backgroundColor: '#394056' }
    },
    {
      if: { priority: 'low', purpose: 'subtle' },
      tokens: { backgroundColor: '#cdcfd5' }
    },
    {
      if: { priority: 'high', purpose: 'subtle' },
      tokens: {
        backgroundColor: '#cdcfd5',
        iconColor: '#f5f5f7',
        textColor: '#f5f5f7'
      }
    },
    {
      if: { priority: 'low', purpose: 'success' },
      tokens: { backgroundColor: '#eaf3f1', iconColor: '#2b826e' }
    },
    {
      if: { priority: 'high', purpose: 'success' },
      tokens: {
        backgroundColor: '#2b826e',
        iconColor: '#eaf3f1',
        textColor: '#eaf3f1'
      }
    },
    {
      if: { priority: 'low', purpose: 'warning' },
      tokens: { backgroundColor: '#f9e8e9', iconColor: '#bf1722' }
    },
    {
      if: { priority: 'high', purpose: 'warning' },
      tokens: {
        backgroundColor: '#bf1722',
        iconColor: '#f9e8e9',
        textColor: '#f9e8e9'
      }
    },
    {
      if: { priority: 'low', purpose: 'error' },
      tokens: { backgroundColor: '#f9e8e9', iconColor: '#bf1722' }
    },
    {
      if: { priority: 'high', purpose: 'error' },
      tokens: {
        backgroundColor: '#bf1722',
        iconColor: '#f9e8e9',
        textColor: '#f9e8e9'
      }
    },
    {
      if: { priority: 'low', purpose: 'offer' },
      tokens: { backgroundColor: '#cdcfd5', iconColor: '#f39d80' }
    },
    {
      if: { priority: 'high', purpose: 'offer' },
      tokens: {
        backgroundColor: '#f39d80',
        iconColor: '#394056',
        textColor: '#394056'
      }
    },
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: '#ffffff',
        textColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, priority: 'low' },
      tokens: {
        backgroundColor: '#394056',
        iconColor: '#ffffff',
        textColor: '#ffffff'
      }
    },
    {
      if: { inverse: true, priority: 'high' },
      tokens: {
        backgroundColor: '#6a7080',
        iconColor: '#ffffff',
        textColor: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: null,
    backgroundGradient: null,
    borderColor: null,
    borderRadius: null,
    borderWidth: null,
    fontName: 'SofiaPro',
    fontSize: 18,
    fontWeight: '400',
    icon: PaletteIconWarningError,
    iconColor: '#394056',
    iconGradient: null,
    iconPaddingTop: 0,
    iconSize: 20,
    marginLeft: 8,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    textColor: '#394056',
    textLineHeight: 1.153
  }
}
export default theme
